const phdData = [
  {
    id: 1,
    name: "Bhavarthe Pramod",
    branch: "EXTC/Jan-2015",
    registration: "15/29-12-2016",
    title:
      "Design of Compact Electromagnetic Band Gap Structures for Enhancement of Microstrip Patch Performances",
    status: "Defended: 5th November 2018",
    guide: "Dr. S S Rathod",
  },
  {
    id: 2,
    name: "Sukanya A Kulkarni",
    branch: "EXTC/Jan-2013",
    registration: "7/24-11-2014",
    title:
      "Efficient peak to average power reduction techniques for OFDM system",
    status: "Defended:4th February 2019",
    guide: "Dr. B.K. Mishra",
  },
  {
    id: 3,
    name: "SonkusareReena S",
    branch: "EXTC/July-2013",
    registration: "10/23-12-2014",
    title:
      "Analysis of FinFET for analog performance and its application in analog circuit",
    status: "Defended: 30th March 2019",
    guide: "Dr. S S Rathod",
  },
  {
    id: 4,
    name: "Madhavi Harish Waghmare",
    branch: "EXTC/Jan-2013",
    registration: "11/30-12-2014",
    title:
      "Enhancement of Bandwidth for broadband communication by using Photonic band gap Structure in optical fiber",
    status: "Defended: 2ndNovember 2019",
    guide: "Dr. KTV Reddy",
  },
  {
    id: 5,
    name: "Tusharika S Banerjee",
    branch: "EXTC/Jan-2013",
    registration: "9/27-11-2014",
    title:
      "Numerical and analytical study for Microwave generation using backward wave oscillator",
    status: "Defended: 15th December 2020",
    guide: "Dr. KTV Reddy",
  },
  {
    id: 6,
    name: "Marathe Dipak Sitaram",
    branch: "EXTC/Jan-2013",
    registration: "6/17-11-2014",
    title: "Parameter optimization of WSN using mixed mode logic",
    status: "Defended: 15th December 2020",
    guide: "Dr. Uday Pandit",
  },
  {
    id: 7,
    name: "Talele Kiran Tulshiram Vasumati",
    branch: "EXTC/Jan-2013",
    registration: "12/21-01-2015",
    title: "Emotion Recognition using facial expression",
    status: "Defended: 7th June 2023",
    guide: "Dr. Kushal Tuckley",
  },
  {
    id: 8,
    name: "Bhagat Narendra Anant",
    branch: "EXTC/Jan-2013",
    registration: "8/25-11-2014",
    title:
      "Current mode technique for optimizing the performance of transmitter and receiver in communication system",
    status: "Defended: 3rd October 2022",
    guide: "Dr. Uday Pandit",
  },
  {
    id: 9,
    name: "Sankhe Darshana Nimesh",
    branch: "EXTC/Jan-2016",
    registration: "18/18-11-2017",
    title:
      "Hardware in the Loop Test Bench for Resonant Inverter Load Characterization",
    status: "Defended: 1st April 2023",
    guide: "Dr. Y S Rao",
  },
  {
    id: 10,
    name: "Kapure Vijay Ramesh",
    branch: "ETRX/July-2017",
    registration: "20/29-01-2019",
    title:
      "Design of Metamaterial Structure for Triple band-notch Ultra wideband Monopole Antenna",
    status: "Defended: 29th June 2023",
    guide: "Dr. S S Rathod",
  },
  {
    id: 11,
    name: "Ambawade Dayanand D",
    branch: "EXTC/Jan-2013",
    registration: "14/04-03-2015",
    title: "Study of Event Correlation Analysis",
    status: ",",
    guide: "Dr. J W Bakal",
  },
  {
    id: 12,
    name: "Sawant Ashwini Satish",
    branch: "EXTC/Jan-2019",
    registration: "39/2-06-2021",
    title: "Medical Image Enhancement and Abnormality Detection",
    status: "Defended: 05th October 2023",
    guide: "Dr Sujata Kulkarni",
  },
  {
    id: 13,
    name: "Keshwani Vidya Rajesh",
    branch: "ETRX/July-2017",
    registration: "27/29-01-2019",
    title:
      "Design of Compact Monopole Antenna with Low Specific Absorption Rate using Metamaterial",
    status: "Thesis Submitted",
    guide: "Dr. S S Rathod",
  },
  {
    id: 14,
    name: "Goswami Siddhant Arun",
    branch: "ETRX/July-2018",
    registration: "41/09-09-2021",
    title:
      "Design and Analysis of Metamaterial Inspired Antenna for Wireless Body Area Network",
    status: "Thesis submitted on 22/02/2024",
    guide: "Dr. Deepak Karia",
  },
  {
    id: 15,
    name: "Bansode Manisha Ravindra",
    branch: "ETRX/July-2017",
    registration: "25/29-01-2019",
    title:
      "Design of compact electromagnetic band gap structures for high speed signaling.",
    status: "Thesis submitted on 10/01/2024",
    guide: "Dr. S S Rathod",
  },
  {
    id: 16,
    name: "Shah Payal Hitesh",
    branch: "ETRX/July-2017",
    registration: "30/29-01-2019",
    title:
      "Modeling and design of silicon neurons and synapse for neuromorphic chip implementation",
    status: "Defended: 19th October 2024",
    guide: "Dr. S S Rathod",
  },
  {
    id: 18,
    name: "Sawant Dattatray S.",
    branch: "EXTC/Jan-2019",
    registration: "38/02-06-2021",
    title:
      "An Investigation on Sensorless BLDC motor control for solar powered submersible water pump.",
    status: "Title Approved",
    guide: "Dr Y S Rao",
  },
  {
    id: 19,
    name: "Raut Karishma Sachin",
    branch: "EXTC/Jan-2020",
    registration: "45/01-06-2022",
    title: "Temporal Dynamics based Real world Multimodal Affect Recognition",
    status: "Title Approved",
    guide: "Dr Sujata Kulkarni",
  },
  {
    id: 20,
    name: "Kadam SejalAmeya",
    branch: "EXTC/Jan-2020",
    registration: "42/31-05-2022",
    title:
      "Investigation of 5G massive MIMO system performance with low resolution ADC and mixed ADC architectures",
    status: "Title Approved",
    guide: "Dr. S S Rathod",
  },
  {
    id: 21,
    name: "RambhiaJeenalMulchan",
    branch: "EXTC/ Jan-2020",
    registration: "47/08-06-2022",
    title:
      "Brain Signal Analysis, Classification and prediction for Imagined Gestures",
    status: "Title Approved",
    guide: "Dr R G Sutar",
  },
  {
    id: 22,
    name: "Hemalata Mahesh Mote",
    branch: "EXTC/ Jan-2020",
    registration: "44/01-06-2022",
    title: "An Optimized Framework for Image Phylogeny Tree Reconstruction",
    status: "Title Approved",
    guide: "Dr Sujata Kulkarni",
  },
  {
    id: 23,
    name: "Milind Pandurang Paraye",
    branch: "EXTC/ Jan-2020",
    registration: "46/09-06-2022",
    title:
      "Data driven impact analysis and load forecasting for Grid-connected PV power-plant",
    status: "Title Approved",
    guide: "Dr R G Sutar",
  },
  {
    id: 24,
    name: "Joshi Sonia",
    branch: "EXTC/ July-2021",
    registration: "",
    title: "Area - Antenna and Microwave",
    status: "Title Approved",
    guide: "Dr Baban U Rindhe",
  },
  {
    id: 25,
    name: "Vatkar Shilpa Naresh",
    branch: "EXTC/July-2021",
    registration: "25-04-2023",
    title:
      "Analysis of soil and crop classification usinf SaR images for agricultural applications",
    status: "Title Approved",
    guide: "Dr Sujata Kulkarni",
  },
  {
    id: 26,
    name: "Gangurde Pallavi Anil",
    branch: "EXTC/ Jan-2023",
    registration: "10/6/2024",
    title:
      "Investigation of NOMA based underrlay cognitive radio networks in 5G systems",
    status: "Title Approved",
    guide: "Dr Sukanya Kulkarni",
  },
  {
    id: 27,
    name: "Sagale Kaustubh Shivaji",
    branch: "EXTC/ Jan-2023",
    registration: "10/6/2024",
    title:
      "Silent Expressions Unvailed : A comprehensive deep learning investigation into nonverbal vocalizations in minimally speaking individuals",
    status: "Title Approved",
    guide: "Dr Sukanya Kulkarni",
  },
  {
    id: 28,
    name: "Mahind Umesh Sarjerao",
    branch: "ETRX/July-2017",
    registration: "23/29-01-2019",
    title:
      "Development of compressive sensing based iterative solution of sparse signal representation problem",
    status: "Title Approved",
    guide: "Dr. Deepak Karia",
  },
  {
    id: 29,
    name: "Thakkar RushaliRitesh",
    branch: "ETRX/July-2017",
    registration: "36/15-07-2019",
    title:
      "An Investigation on reliable and efficient power electronic converters and their control for active balancing of energy cells.",
    status: "Title Approved",
    guide: "Dr.Y S Rao",
  },
  {
    id: 30,
    name: "Bera Aprajita S.",
    branch: "ETRX/Jan-2019",
    registration: "37/06-07-2021",
    title: "Power Integrity Analysis and Design for High Speed PCB",
    status: "Title Approved",
    guide: "Dr. Sudhakar Mande",
  },
  {
    id: 31,
    name: "Tulashidas Mane",
    branch: "ETRX/Jan-2022",
    registration: "10/6/2024",
    title:
      "Design of a compact microwave sensor for dielectric characterization",
    status: "Title Approved",
    guide: "Dr. Reena Sonkusare",
  },
  {
    id: 32,
    name: "Govind Tukaram Haldankar",
    branch: "ETRX/Jan-2023",
    registration: "16-12-2024",
    title: "",
    status: "Title not approved yet",
    guide: "Dr B N Chaudhari",
  },
];

export default phdData;
